// extracted by mini-css-extract-plugin
module.exports = {"box":"legitimation_box__2Wp0I","wrapper":"legitimation_wrapper__3Z1EJ"};